/* Write a review — opens/closes the popup. Markup lives in sections/write-review.liquid. */

if (!customElements.get('write-review')) {
  class WriteReview extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.querySelector('[data-write-review-open]')?.addEventListener('click', () => {
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
      });

      this.querySelector('[data-write-review-close]')?.addEventListener('click', () => this.dialog.close());

      // Click on the backdrop (outside the popup box) closes it.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
    }
  }

  customElements.define('write-review', WriteReview);
}
